import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../../services/data.service';

@Component({
	selector: 'members-detail-basic-information',
	templateUrl: './basic.html'
})
export class MembersDetailBasicInformation {
	@Input() form: FormGroup;
	@Input() action: string;
	@Input() memberData: Object;

	public constructor(
		private dataService: DataService
	) {
	}
}


// WEBPACK FOOTER //
// ./src/pages/members/detail/basic/basic.ts